const getBoolValueFromEnv = key => {
    if (!process.env[key]) return false
    return JSON.parse(process.env[key])
}

const getDefaultValueFromEnv = key => {
    if (!process.env[key]) return ''
    return process.env[key]
}

const envConfig = {
    tawkPropId: getDefaultValueFromEnv('REACT_APP_TAWK_PROPERTY_ID'),
    tawkWidgetId: getDefaultValueFromEnv('REACT_APP_TAWK_WIDGET_ID'),
    googleTagId: getDefaultValueFromEnv('REACT_APP_GOOGLE_TAG_MANAGER_ID'),
    clarityId: getDefaultValueFromEnv('REACT_APP_CLARITY_ID'),
    isReadOnlyModeEnabled: getBoolValueFromEnv('REACT_APP_READ_ONLY_MODE'),
    isPaymentEnabled: getBoolValueFromEnv('REACT_APP_PAYMENT_ENABLED'),
    isRegionUnified: getBoolValueFromEnv('REACT_APP_REGION_UNIFIED'),
    customerMediaUrl: getDefaultValueFromEnv('REACT_APP_CUSTOMER_MEDIA_URL'),
    isSelfHosted: getBoolValueFromEnv('REACT_APP_IS_SELF_HOSTED'),
    isIntegrationEnabled: getBoolValueFromEnv('REACT_APP_INTEGRATIONS_ENABLED'),
    appEnv: getDefaultValueFromEnv('REACT_APP_ENV'),
    locale: getDefaultValueFromEnv('REACT_APP_LOCALE'),
    alertDuration: getDefaultValueFromEnv('REACT_APP_ALERT_DURATION'),
    siteUrl: getDefaultValueFromEnv('REACT_APP_SITE_URL'),
    maintenanceWindow: getDefaultValueFromEnv('REACT_APP_MAINTENANCE_WINDOWS'),
    showInfoMsg: getBoolValueFromEnv('REACT_APP_SHOW_INFO_MESSAGE'),
    isFeedbackButtonEnabled: getBoolValueFromEnv('REACT_APP_FEEDBACK_BUTTON_ENABLED'),
    serverMonitoringliveUpdateTime: getDefaultValueFromEnv('REACT_APP_SERVER_MONITORING_LIVE_UPDATE_TIME'),
    defaultRegion: getDefaultValueFromEnv('REACT_APP_DEFAULT_REGION'),
    mainLocations: getDefaultValueFromEnv('REACT_APP_MAIN_LOCATIONS'),
    liveUpdateTime: getDefaultValueFromEnv('REACT_APP_LIVE_UPDATE_TIME'),
    publicApiBaseUrl: getDefaultValueFromEnv('REACT_APP_PUBLIC_API_BASE_URL'),
    firstDataWaitingTime: getDefaultValueFromEnv('REACT_APP_FIRST_DATA_WAITING_TIME'),
    baseUrl: getDefaultValueFromEnv('REACT_APP_BASE_URL'),
    slackClientId: getDefaultValueFromEnv('REACT_APP_SLACK_CLIENT_ID'),
    discordClientId: getDefaultValueFromEnv('REACT_APP_DISCORD_CLIENT_ID'),
    responseUpdateTime: getDefaultValueFromEnv('REACT_APP_RESOURCES_UPDATE_TIME'),
    externalStatuspageDomain: getDefaultValueFromEnv('REACT_APP_EXTERNAL_STATUSPAGE_DOMAIN'),
    statuspageCnameValue: getDefaultValueFromEnv('REACT_APP_STATUSPAGE_CNAME_VALUE'),
    isCustomDomainEnabled: getBoolValueFromEnv('REACT_APP_CUSTOM_DOMAIN_ENABLED'),
    telegramBotUsername: getDefaultValueFromEnv('REACT_APP_TELEGRAM_BOT_USERNAME'),
    isTelegramWebhookUrlEnabled: getBoolValueFromEnv('REACT_APP_TELEGRAM_WEBHOOK_ENABLED')
}

export {
    getBoolValueFromEnv,
    getDefaultValueFromEnv,
    envConfig}
